import { PROVINCES } from '@/constants';
import OptionsHelper from '@/utils/OptionsHelper';
import { LocationFormControlName } from '../enums';

export const PROVINCE_OPTIONS = OptionsHelper.mapValuesIntoOptions(Object.values(PROVINCES));

export const LOCATION_DEFAULT_VALUES = {
  [LocationFormControlName.Province]: '',
  [LocationFormControlName.City]: '',
  [LocationFormControlName.Community]: '',
};
